import {changeValue} from '@github-ui/form-utils'
import {remoteForm, type ErrorWithResponse} from '@github-ui/remote-form'
import {TemplateInstance} from '@github/template-parts'
import {showGlobalError} from '../behaviors/ajax-error'
import {resetUserAddForm} from './user-add'

function isErrorWithResponse(error: unknown): error is ErrorWithResponse {
  return error instanceof Error && 'response' in error
}

function flashMessage(message: string, type = 'notice') {
  const template = document.querySelector<HTMLTemplateElement>('.js-flash-template')
  const flashContainer = document.querySelector<HTMLElement>('#js-flash-container')
  if (!template || !flashContainer) return

  const node = document.importNode(
    new TemplateInstance(template, {
      className: `flash-${type}`,
      message,
    }),
    true,
  )

  for (const child of Array.from(flashContainer.children)) {
    if (!child.classList.contains('js-flash-template')) {
      flashContainer.removeChild(child)
    }
  }
  flashContainer.appendChild(node)
}

remoteForm('.js-remote-submit', async function (form, wants) {
  const dialog = form.closest('#block-user-confirmation-dialog') as HTMLDialogElement
  const response = await wants.json()

  const group = document.querySelector<HTMLElement>('.js-user-block-settings-list')
  const list = group?.querySelector<HTMLElement>('.js-blocked-list')
  const blank = group?.querySelector<HTMLElement>('.js-user-block-blank-slate')

  resetUserAddForm(form, false)
  const input = document.querySelector<HTMLInputElement>('.js-add-blocked-user-field')

  if (input) {
    changeValue(input, '')
  }

  if (dialog && 'open' in dialog) {
    dialog.close()
  }

  // Redirects so we can see the banners for unblock/block actions
  if (response.json.redirect) {
    window.location.href = response.json.redirect
  }

  if (blank) blank.hidden = true
  if (list) list.hidden = false
})

remoteForm('.js-close-content-form', async function (form, wants) {
  try {
    const response = await wants.json()
    flashMessage(response.json.message, 'success')
  } catch (error) {
    if (isErrorWithResponse(error)) {
      try {
        const payload = error.response.json
        if (payload && typeof payload === 'object' && 'error' in payload && typeof payload.error === 'string') {
          flashMessage(payload.error, 'error')
          return
        }
      } catch {
        // Fall through to the generic error when the response body is not valid JSON.
      }
    }

    showGlobalError()
  }
})
